import { useState } from 'react';

import Stack from '@liquidweb-dev/undercurrent/Stack';
import Typography from '@liquidweb-dev/undercurrent/Typography';
import HookedCheckboxSimple from 'components/Form/HookedCheckbox';
import HookedSubmit from 'components/Form/HookedSubmit';
import LWForm, { type FormSubmitHandler } from 'components/LWForm';
import { type CancellationFormData } from './constants';

export interface LastServerCleanupProps {
	formValues: CancellationFormData;
	onFormValuesChange: (values: CancellationFormData) => void;
	onSubmit: FormSubmitHandler<CancellationFormData>;
}

const LastServerCleanup = ({
	formValues,
	onFormValuesChange,
	onSubmit,
}: LastServerCleanupProps) => {
	const [formErrors, setFormErrors] = useState({
		cleanup_assets: '',
	});

	return (
		<LWForm
			values={formValues}
			onValuesChange={onFormValuesChange}
			errors={formErrors}
			onErrorsChange={setFormErrors}
			onSubmit={onSubmit}
		>
			<Stack
				direction="column"
				useFlexGap
				sx={{
					width: '100%',
					gap: 300,
				}}
			>
				<Stack
					direction="column"
					useFlexGap
					sx={{
						gap: 200,
					}}
				>
					<Typography
						variant="title-xs"
						sx={{
							fontWeight: '500',
							color: ({ vars }) => vars.palette.uc.text.main,
						}}
					>
						This is the last server on your account and a bit of additional
						clean up is required
					</Typography>
					<Typography
						variant="body-sm"
						sx={{ color: ({ vars }) => vars.palette.uc.text.main }}
					>
						Since this is the last server on your account, you have the option
						to clean up any remaining services or data to avoid future charges
						or confusion.
					</Typography>
				</Stack>
				<Stack
					direction="column"
					sx={{
						gap: 200,
					}}
				>
					<Stack
						direction="row"
						sx={{
							alignItems: 'flex-start',
							gap: 100,
						}}
					>
						<HookedCheckboxSimple
							name="cleanup_assets"
							sx={({ vars }) => ({
								width: 18,
								height: 18,
								color: vars.palette.uc.border.strong,
							})}
							FormControlLabelProps={{
								style: { marginLeft: 0, marginRight: 0 },
							}}
						/>
						<Typography
							sx={{
								color: ({ vars }) => vars.palette.uc.text.main,
							}}
						>
							<Typography
								component="span"
								variant="body-sm"
								sx={{ fontWeight: 500 }}
							>
								Optional:
							</Typography>{' '}
							<Typography component="span" variant="body-sm">
								Disable auto-renewal for all domain registrations and SSL
								certificates, and remove any remaining DNS zones on this
								account.
							</Typography>
						</Typography>
					</Stack>

					<Stack
						sx={{
							alignItems: 'center',
						}}
					>
						<HookedSubmit size="large" variant="primary" fullWidth>
							Continue
						</HookedSubmit>
					</Stack>
				</Stack>
			</Stack>
		</LWForm>
	);
};

export default LastServerCleanup;
